import { Language } from '../constants';
export const PASSWORD_FIELD_TRANSLATION_KEYS = {
  accessibleShowPasswordLabel: 'component.PasswordField.accessibleShowPasswordLabel',
  accessibleHidePasswordLabel: 'component.PasswordField.accessibleHidePasswordLabel'
};
export const PASSWORD_FIELD_TRANSLATIONS = {
  [Language.EN]: {
    [PASSWORD_FIELD_TRANSLATION_KEYS.accessibleShowPasswordLabel]: 'Show password',
    [PASSWORD_FIELD_TRANSLATION_KEYS.accessibleHidePasswordLabel]: 'Hide password'
  },
  [Language.PL]: {
    [PASSWORD_FIELD_TRANSLATION_KEYS.accessibleShowPasswordLabel]: 'Pokaż hasło',
    [PASSWORD_FIELD_TRANSLATION_KEYS.accessibleHidePasswordLabel]: 'Ukryj hasło'
  },
  [Language.CS]: {
    [PASSWORD_FIELD_TRANSLATION_KEYS.accessibleShowPasswordLabel]: 'Zobrazit heslo',
    [PASSWORD_FIELD_TRANSLATION_KEYS.accessibleHidePasswordLabel]: 'Skrýt heslo'
  },
  [Language.SK]: {
    [PASSWORD_FIELD_TRANSLATION_KEYS.accessibleShowPasswordLabel]: 'Ukázať heslo',
    [PASSWORD_FIELD_TRANSLATION_KEYS.accessibleHidePasswordLabel]: 'Skryť heslo'
  }
};